exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n#scrollTopBtn[data-v-cc39b020] {\n  position: relative;\n  bottom: 0;\n  /* left: 0px; */\n  top: 9px;\n  right: 27px;\n  z-index: 99;\n  border: none;\n  cursor: pointer;\n  width: 27px;\n  height: 27px;\n}\n#scrollTopBtn .icon-up[data-v-cc39b020] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + require("../../../static/img/up-circle.svg") + ") no-repeat center;\n  mask: url(" + require("../../../static/img/up-circle.svg") + ") no-repeat center;\n  background: url(" + require("../../../static/img/up-circle-blue.svg") + ");\n}\n/*#scrollTopBtn:hover {\n  background-color: #555; !* Add a dark-grey background on hover *!\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc39b020","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/utils/ScrollTop.vue
// module id = 1618
// module chunks = 1